import {createContext} from "react"

export const PageContext = createContext({page:{isLoading:false}, setPage:()=>{}});

